// TODO: implement edge cases (including infinite loops)
// TODO: implement detailed error handling
import { RandomEngine, RandomGenerator } from '@grandom/core';
import BigIntFilter from '../BigIntFilter';
const DEFAULT_LOOP_GUARD = 1000000;
export default class RandomBigInt extends RandomGenerator {
    bigint(arg1, arg2, arg3) {
        if (typeof arg1 !== 'undefined') {
            let min = RandomEngine.DEFAULT_BIGINT_MINIMUM;
            let max = RandomEngine.DEFAULT_BIGINT_MAXIMUM;
            let includeMin = RandomEngine.DEFAULT_INCLUDE_MINIMUM;
            let includeMax = RandomEngine.DEFAULT_INCLUDE_MAXIMUM;
            let hasFilter = false;
            // let includeFilter: undefined | IntegerFilter
            let excludeFilter = false;
            if (typeof arg1 === 'bigint') {
                if (typeof arg2 === 'undefined') {
                    max = arg1;
                }
                if (typeof arg2 === 'bigint') {
                    min = arg1;
                    max = arg2;
                }
                if (typeof arg3 === 'object' && arg3 !== null) {
                    if (typeof arg3.includeMinimum === 'boolean') {
                        includeMin = arg3.includeMinimum;
                    }
                    if (typeof arg3.includeMaximum === 'boolean') {
                        includeMax = arg3.includeMaximum;
                    }
                    // if ('include' in arg3) {
                    //   includeFilter = new IntegerFilter(arg3.include)
                    //   hasFilter = true
                    // }
                    if ('exclude' in arg3) {
                        excludeFilter = new BigIntFilter(arg3.exclude);
                        hasFilter = true;
                    }
                }
            }
            if (hasFilter) {
                const loopGuard = DEFAULT_LOOP_GUARD;
                let loop = 0;
                while (true) {
                    if (loop >= loopGuard) {
                        throw new Error(`Infinite loop guard reached after ${loopGuard} iterations.`);
                    }
                    const bigint = this._engine.nextBigInt(min, max, includeMin, includeMax);
                    if (excludeFilter !== false) {
                        if (excludeFilter.matches(bigint)) {
                            loop++;
                            continue;
                        }
                    }
                    return bigint;
                }
            }
            return this._engine.nextBigInt(min, max, includeMin, includeMax);
        }
        return this._engine.nextBigInt();
    }
}
//# sourceMappingURL=index.js.map